import { userService } from '@/user/userService';
import router from '@/router'

export default {
  login({ dispatch, commit }, payload) {
    commit('loginRequest', payload.email);

    userService.login(payload.email, payload.pass)
      .then(
        user => {
          commit('loginSuccess', user);
          router.push(router.currentRoute.query.to || '/');
        },
        error => {
          commit('loginFailure', error);

          payload.notify({
              time: 2500,
              title: 'Error',
              // text: error.message,
              text: 'Error logging in. Please try again.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
          });
        }
      );
  },
  logout({ commit }) {
    userService.logout();
    commit('logout');
    router.push(router.currentRoute.query.to || '/pages/login');
  }
}
